<template>
  <div>
    <button
      @click="$emit('click')"
      type="button"
      style="z-index: 10"
      class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-teal-700 focus:shadow-outline-teal active:bg-green-700 transition ease-in-out duration-150"
    >
      <font-awesome-icon
        icon="cart-plus"
        class="fa-fw nav-icon mr-1"
      ></font-awesome-icon>
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: "AddToCart",

  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>

<style scoped>
button {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
